import React from 'react';
import styled from '@emotion/styled';
import SummaryBody from './SummaryBody';
import SummaryHead from './SummaryHead';

interface Summary {
  imgSrc: string;
  institutionName: string;
  jobTitle: string;
  yearsOfExperience: string;
  pay: number;
  className?: string;
  jobDescription?: string;
  location: string;
  payInterval: string;
  jobStartDate?: string;
  jobEndDate?: string;
}

const JobSummaryModal: React.FC<Summary> = ({
  imgSrc,
  institutionName,
  jobTitle,
  yearsOfExperience,
  pay,
  className,
  jobDescription,
  payInterval,
  location,
  jobStartDate,
  jobEndDate,
}) => {
  return (
    <Container>
      <SummaryHead
        imgSrc={'/static/gif/happyAnimal.gif'}
        title={jobTitle}
        institutionName={institutionName}
        yearsOfExperience={yearsOfExperience}
        pay={pay}
        payInterval={payInterval}
        location={location}
        jobStartDate={jobStartDate}
        jobEndDate={jobEndDate}
      />
      <SummaryBody jobDescription={jobDescription} />
    </Container>
  );
};

export default JobSummaryModal;

const Container = styled.div`
  background-color: white;
  color: black;
`;
